import React from 'react';

import { getUserProfileUrl } from '@adsk/acs-sc-web-platform-api';
import A from '@adsk/alloy-react-a';
import { Flex, Text } from '@adsk/alloy-react-box';
import Divider from '@adsk/alloy-react-divider';
import theme from '@adsk/alloy-react-theme';

import { useTranslation } from '../i18n';

export const MFATooltipContent = () => {
  const { t } = useTranslation();

  return (
    <Flex flexDirection="column">
      <Text typography="heading5">{t('MFA_REQUIRED')}</Text>
      <Text>
        {t('TWO_STEPS_VERIFICATION_IS_REQUIRED_TO_ACCESS_THIS_PROJECT')}
      </Text>
      <Divider
        style={{
          marginTop: theme.spacing.medium,
          marginBottom: theme.spacing.small,
        }}
      />
      <A
        style={{ color: theme.colors.adskBlue100 }}
        href={`${getUserProfileUrl()}/security`}
        onClick={(e) => e.stopPropagation()}
      >
        {t('SETUP_TWO_STEPS_VERIFICATION')}
      </A>
    </Flex>
  );
};
